export const MODEL_OPTIONS = [
    { value: '', label: 'Seleziona un modello' },
    // OpenAI
    { value: 'gpt-5.6-sol', label: 'GPT-5.6 Sol (OpenAI)' },
    { value: 'gpt-5.6-terra', label: 'GPT-5.6 Terra (OpenAI)' },
    { value: 'gpt-5.6-luna', label: 'GPT-5.6 Luna (OpenAI)' },
    { value: 'gpt-5.2-pro-2025-12-11', label: 'GPT-5.2 Pro (OpenAI)' },
    { value: 'gpt-5.2-2025-12-11', label: 'GPT-5.2 (OpenAI)' },
    { value: 'gpt-5.2-codex', label: 'GPT-5.2 Codex (OpenAI)' },
    { value: 'gpt-5.1-2025-11-13', label: 'GPT-5.1 (OpenAI)' },
    { value: 'gpt-5-nano-2025-08-07', label: 'GPT-5 Nano (OpenAI)' },
    { value: 'gpt-5-mini-2025-08-07', label: 'GPT-5 Mini (OpenAI)' },
    { value: 'gpt-5-2025-08-07', label: 'GPT-5 (OpenAI)' },
    { value: 'gpt-4.1-2025-04-14', label: 'GPT-4.1 (OpenAI)' },
    { value: 'gpt-4o', label: 'GPT-4o (OpenAI)' },
    { value: 'gpt-4o-mini', label: 'GPT-4o Mini (OpenAI)' },
    // Anthropic
    { value: 'claude-sonnet-5', label: 'Claude Sonnet 5 (Anthropic)' },
    { value: 'claude-opus-4-8', label: 'Claude Opus 4.8 (Anthropic)' },
    { value: 'claude-opus-4-7', label: 'Claude Opus 4.7 (Anthropic)' },
    { value: 'claude-opus-4-6', label: 'Claude Opus 4.6 (Anthropic)' },
    { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 (Anthropic)' },
    { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5 (Anthropic)' },
    { value: 'claude-opus-4-5', label: 'Claude Opus 4.5 (Anthropic)' },
    { value: 'claude-sonnet-4-5', label: 'Claude Sonnet 4.5 (Anthropic)' },
    // Google
    { value: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash (Google)' },
    { value: 'gemini-1.5-pro', label: 'Gemini 1.5 Pro (Google)' },
    { value: 'gemini-1.5-flash', label: 'Gemini 1.5 Flash (Google)' },
    // Mistral
    { value: 'mistral-large-latest', label: 'Mistral Large (Mistral)' },
    { value: 'mistral-medium-latest', label: 'Mistral Medium (Mistral)' },
    { value: 'mistral-small-latest', label: 'Mistral Small (Mistral)' },
    { value: 'codestral-latest', label: 'Codestral (Mistral)' },
    // DeepSeek
    { value: 'deepseek-chat', label: 'DeepSeek Chat (DeepSeek)' },
    { value: 'deepseek-coder', label: 'DeepSeek Coder (DeepSeek)' },
    // Meta
    { value: 'llama-3.3-70b', label: 'Llama 3.3 70B (Meta)' },
    { value: 'llama-3.1-405b', label: 'Llama 3.1 405B (Meta)' },
];

export const EMBEDDING_OPTIONS = [
    { value: '', label: 'Seleziona un modello' },
    // OpenAI
    { value: 'text-embedding-3-large', label: 'Text Embedding 3 Large (OpenAI)' },
    { value: 'text-embedding-3-small', label: 'Text Embedding 3 Small (OpenAI)' },
    { value: 'text-embedding-ada-002', label: 'Text Embedding Ada 002 (OpenAI)' },
    // Cohere
    { value: 'embed-english-v3.0', label: 'Embed English v3.0 (Cohere)' },
    { value: 'embed-multilingual-v3.0', label: 'Embed Multilingual v3.0 (Cohere)' },
    // Voyage
    { value: 'voyage-3', label: 'Voyage 3 (Voyage)' },
    { value: 'voyage-3-lite', label: 'Voyage 3 Lite (Voyage)' },
    // Google
    { value: 'text-embedding-004', label: 'Text Embedding 004 (Google)' },
];